module.exports = __webpack_public_path__ + "img/female_resultC.870a39ce.png";